<template>
  <div>
    <ed-funcao :intFuncaoId="0" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdFuncao from "@/components/cadastro/funcao/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdFuncao },
  mounted() {},
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>